<script setup>
import { computed, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from "../../../../../layouts/nav/SNB.vue";
import MypageProposalListView from "../proposal/MypageProposalListView.vue";
import MypageProposalCreateView from "../proposal/MypageProposalCreateView.vue";
import MypageResumeCorporationView from "../proposal/MypageResumeCorporationView.vue";
import MypageSearchResumeView from "../proposal/MypageSearchResumeView.vue";
import MypageResumeLikeView from "../proposal/MypageResumeLikeView.vue";
import MypageProposalUserListView from "../proposal/MypageProposalUserListView.vue";
import MypageApplyView from "../proposal/MypageApplyView.vue";

const route = useRoute();
const router = useRouter();
const tabRef = ref(null);

const snbKey = ref(0);

const tabOptions = [
  { label: '채용 제안 현황', value: 'proposal' },
  { label: '인재 채용 현황', value: 'hire' },
  { label: '입사지원 현황', value: 'apply' },
  { label: '인재 검색', value: 'search' },
  { label: '관심 인재', value: 'like' },
];

const getTabValue = (tab) => {
  return tabOptions.some(option => option.value === tab) ? tab : tabOptions[0].value;
}

const selectedTabValue = ref(getTabValue(route.query.tab));
const isProposalCreateView = computed(() => route.query.proposalView === 'create');
const isProposalUserListView = computed(() => route.query.proposalView === 'user');

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;

  if (tabRef.value) {
    tabRef.value.init(tab.value);
  }

  if (selectedTabValue.value === tab.value) {
    return;
  }

  router.push({ query: { ...route.query, tab: tab.value } });
};

onMounted(() => {
  const tabFromQuery = route.query.tab;
  if (tabFromQuery && tabOptions.some(option => option.value === tabFromQuery)) {
    selectedTabValue.value = tabFromQuery;

    if(tabRef.value) {
      tabRef.value.init(tabFromQuery);
    }
  }
});
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB :key="snbKey" class="snb" />
        <div class="content">
          <div class="sub-title">
            <h3>상시채용관 현황</h3>
          </div>
          <div class="tab-wrap mb-sm">
            <KSATab
                ref="tabRef"
                :options="tabOptions"
                @change="onChangeTab"
                style="grid-template-columns: repeat(5, 1fr);"
            />
          </div>
          <div v-if="selectedTabValue === 'proposal'">
            <MypageProposalCreateView v-if="isProposalCreateView" />
            <MypageProposalUserListView v-else-if="isProposalUserListView" />
            <MypageProposalListView v-else />
          </div>
          <div v-else-if="selectedTabValue === 'hire'">
            <MypageResumeCorporationView />
          </div>
          <div v-else-if="selectedTabValue === 'apply'">
            <MypageApplyView />
          </div>
          <div v-else-if="selectedTabValue === 'search'">
            <MypageSearchResumeView />
          </div>
          <div v-else-if="selectedTabValue === 'like'">
            <MypageResumeLikeView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>
